import { render, staticRenderFns } from "./SendLineMessageV2.vue?vue&type=template&id=56376c86&scoped=true"
import script from "./SendLineMessageV2.vue?vue&type=script&lang=js"
export * from "./SendLineMessageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56376c86",
  null
  
)

export default component.exports